export const typeOfClientOptions = [
  { value: 'stationary', label: 'Stacjonarny', fieldName: 'typeOfClient', id: 1 },
  { value: 'chain', label: 'Sieciowy', fieldName: 'typeOfClient', id: 2 },
];
